export const detailedLFV1 = ["OriginalAsIsLtv", "OriginalLtcLtp", "OriginalLtc"];

export const detailedPropPLFV1 = [
  "ESRIPopulationDensity",
  "ZillowCBSA",
  "AdjustedAsIsValue",
];
